import axios from 'axios';

// API Configuration
const getApiUrl = () => {
  // Priority 1: Check if REACT_APP_API_URL is explicitly set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Priority 2: Use defaults based on NODE_ENV
  if (process.env.NODE_ENV === 'production') {
    // Production default - Railway URL
    return 'https://jobapplicationagent-production.up.railway.app';
  }

  // Development default - localhost
  return 'http://localhost:5000';
};

export const API_URL = getApiUrl();

// Log the configuration for debugging
console.log('🔧 API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  'Using API URL': API_URL
});

// Helper function to build API endpoints
export const getApiEndpoint = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}`;
};

// Create configured axios instance
export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const config = { API_URL, getApiEndpoint, apiClient };
export default config;
